import React from 'react';
import { Navigate } from 'react-router-dom';

// Redirect to Tariff Management page - approval is handled in the "Pending Approval" tab
const TariffApprovalPage = () => {
  return <Navigate to="/admin/tariffs" replace />;
};

export default TariffApprovalPage;
